import React, { Component } from "react";
import { Card, Table, Thead, Tbody, Tr, Th, Td } from "ui-kit-ck-consultant";
import { ExportCSV } from "react-export-csv";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getPercentageValue, getCurrencyValue } from "../../../utils/general";

export class DetailOfVolumetriesAndCost extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDownload: false,
    };
  }

  render() {
    let data = [];

    if (this.props.data.length) {
      this.props.data[0].forEach((month, idxRow) => {
        data.push({});
        this.props.data.forEach((element, idxCol) => {
          const value = element[idxRow];
          data[idxRow][idxCol] =
            ![0, 6, 12].includes(idxCol) && typeof value === "number"
              ? Math.round(value * 100) / 100
              : value;
        });
      });
    }

    return (
      <>
        <Card
          title="Détail des volumétries et coût"
          className="mb-10 mb-20-xl"
          classNameChildren="overflow-x-auto"
          action={<FontAwesomeIcon icon={faDownload} />}
          onClick={() => this.setState({ isDownload: true })}
        >
          <Table>
            <Thead>
              <Tr>
                <Th rowSpan={2}>Mois</Th>
                <Th colSpan={6}>
                  {this.props.isElec ? "Électrique" : "Camping Car"}
                </Th>
                <Th colSpan={6}>
                  {this.props.isElec ? "Hybride" : "Caravanes"}
                </Th>
              </Tr>
              <Tr>
                <Th>Taux de VEI</Th>
                <Th>Taux EAD</Th>
                <Th>
                  Coût global du sinistre (Rép + Diff de valeurs VEI et RPV),
                  cumul
                </Th>
                <Th>Variation N-1 du coût global du sinistre</Th>
                <Th>Coût moyen pièces</Th>
                <Th>Nbre dossiers VVNR Clôturés</Th>
                <Th>Taux de VEI</Th>
                <Th>Taux EAD</Th>
                <Th>
                  Coût global du sinistre (Rép + Diff de valeurs VEI et RPV),
                  cumul
                </Th>
                <Th>Variation N-1 du coût global du sinistre</Th>
                <Th>Coût moyen pièces</Th>
                <Th>Nbre dossiers VVNR Clôturés</Th>
              </Tr>
            </Thead>
            <Tbody>
              {this.props.data.length
                ? this.props.data[0].map((month, idxRow) => (
                    <Tr key={idxRow}>
                      {this.props.data.map((element, idxCol) => (
                        <Td key={idxCol}>
                          {[1, 2, 7, 8].includes(idxCol)
                            ? getPercentageValue(element[idxRow])
                            : [3, 4, 5, 9, 10, 11].includes(idxCol)
                            ? getCurrencyValue(element[idxRow])
                            : element[idxRow]}
                        </Td>
                      ))}
                    </Tr>
                  ))
                : null}
            </Tbody>
          </Table>
        </Card>
        {this.state.isDownload ? (
          <ExportCSV
            header={[
              {
                name: "Mois",
                key: "0",
              },
              {
                name: "Taux de VEI",
                key: "1",
              },
              {
                name: "Taux EAD",
                key: "2",
              },
              {
                name: "Coût global du sinistre (Rép + Diff de valeurs VEI et RPV), cumul",
                key: "3",
              },
              {
                name: "Variation N-1 du coût global du sinistre",
                key: "4",
              },
              {
                name: "Coût moyen pièces",
                key: "5",
              },
              {
                name: "Nbre dossiers VVNR Clôturés",
                key: "6",
              },
              {
                name: "Taux de VEI",
                key: "7",
              },
              {
                name: "Taux EAD",
                key: "8",
              },
              {
                name: "Coût global du sinistre (Rép + Diff de valeurs VEI et RPV), cumul",
                key: "9",
              },
              {
                name: "Variation N-1 du coût global du sinistre",
                key: "10",
              },
              {
                name: "Coût moyen pièces",
                key: "11",
              },
              {
                name: "Nbre dossiers VVNR Clôturés",
                key: "12",
              },
            ]}
            data={data}
            separator={";"}
            callback={() =>
              this.setState({
                isDownload: false,
              })
            }
            isDownload={true}
            filename={`Détail des volumétries et coût ${this.props.year}.csv`}
          />
        ) : null}
      </>
    );
  }
}

export default DetailOfVolumetriesAndCost;
